import {IBannerVariables, VariablesType} from "./types";

export const defaultChildDesignVariables = {
    Banner: {
        BGColor: {
            type: 'ColorInput',
            value: '#6afafa'
        }
    },
    CTA: {
        Border: {
            type: 'Input',
            value: ''
        },
        BorderRadius: {
            type: 'Input',
            value: '1px'
        },
        TextColor: {
            type: 'ColorInput',
            value: '#dddddd'
        }
    },
}

export const defaultChildFeedVariables = {
    pre: {
        feed: {
            name: {
                type: 'Input',
                value: 'waitr'
            }
        }
    },
    post: {
        columns: {
            Name: {
                type: 'Input',
                value: 'Title'
            },
            ImageUrl: {
                type: 'Input',
                value: 'Image'
            }
        },
    }
}

export const defaultMasterDesignVariables = {
    CTA: {
        BGColor: {
            type: 'ColorInput',
            value: '#ef7335'
        },
        Border: {
            type: 'Input',
            value: ''
        },
        BorderRadius: {
            type: 'Input',
            value: '5px'
        },
        Shadow: {
            type: 'Input',
            value: '1px 1px 14px #ccc'
        },
        TextColor: {
            type: 'ColorInput',
            value: '#ffffff'
        }
    },
    Discount: {
        BGColor: {
            type: 'ColorInput',
            value: '#a64b4b'
        }
    },
    Image: {
        Border: {
            type: 'Input',
            value: '1px dashed red'
        },
        BorderRadius: {
            type: 'Input',
            value: '50px 20px'
        },
        Crop: {
            options: [
                {
                    label: 'Cover',
                    value: 'cover'
                },
                {
                    label: 'Contain',
                    value: 'contain'
                }
            ],
            type: 'Select',
            value: 'cover'
        }
    },
    Logo: {
        BGColor: {
            type: 'ColorInput',
            value: '#ef7335'
        },
        Size: {
            type: 'Input',
            value: '10vh'
        },
        URL: {
            type: 'Input',
            value: 'http://se.remerge.io.s3-eu-west-1.amazonaws.com/assets/images/logo.png'
        }
    },
    Offer: {
        Brand: {
            type: 'Input',
            value: ''
        },
        Description: {
            type: 'Input',
            value: ''
        },
        DiscountedPrice: {
            type: 'Input',
            value: ''
        },
        Message: {
            type: 'Input',
            value: ''
        },
        OriginalPrice: {
            type: 'Input',
            value: ''
        },
    }
}

export const defaultMasterFeedVariables = {
    Feed: {
        Name: {
            type: 'Input',
            value: 'waitr'
        }
    },
    Columns: {
        Id: {
            type: 'Input',
            value: 'Id'
        },
        Name: {
            type: 'Input',
            value: 'Title'
        },
        ImageUrl: {
            type: 'Input',
            value: 'Image'
        }
    },
}


export const defaultBannerVariables:IBannerVariables = {
    id: "new",
    variablesType: VariablesType.DESIGN,
    name: "default banner variables",
    variables: {},
    created: {},
    updated: {},
};

export const defaultMasterDesignBannerVariables: IBannerVariables = {
    id: "master_design",
    isMaster: true,
    variablesType: VariablesType.DESIGN,
    name: "default master design variables",
    variables: defaultMasterDesignVariables,
    created: {},
    updated: {},
};


export const defaultChildDesignBannerVariables: IBannerVariables = {
    id: "child_design",
    parentId: "master_design",
    variablesType: VariablesType.DESIGN,
    name: "default child design variables",
    variables: defaultChildDesignVariables,
    created: {},
    updated: {},
};

export const defaultMasterFeedBannerVariables: IBannerVariables = {
    id: "master_feed",
    isMaster: true,
    variablesType: VariablesType.FEED,
    name: "default master feed variables",
    variables: defaultMasterFeedVariables,
    created: {},
    updated: {},
};


export const defaultChildFeedBannerVariables: IBannerVariables = {
    id: "child_feed",
    parentId: "master_feed",
    variablesType: VariablesType.FEED,
    name: "default child feed variables",
    variables: defaultChildFeedVariables,
    created: {},
    updated: {},
};
